import {DateTime, PhoneNumber} from "./models";
import routedefs from "./vRoutedefs";
import {queryParams} from "./utils";

export default class Routes {
    private static baseurl = "/web/api";

    static terminalLocations(orgnum: number) {
        return `${Routes.baseurl}/company/${orgnum}/terminal-locations`;
    }
    static terminalLocationcreate() {
        return `${Routes.baseurl}/terminal-location`;
    }
    static terminalLocationUpdate(locid: number) {
        return this.fetchTerminalLocation(locid);
    }

    static defaultCompany() {
        return `${Routes.baseurl}/company`;
    }
    static company(orgnum: number) {
        return `${Routes.baseurl}/company/${orgnum}`;
    }

    static hmsregActivated(orgnum: number) {
        return Routes.company(orgnum)+`/hmsreg/active`;
    }

    static exportserviceInfoList(orgnum: number) {
        return Routes.company(orgnum)+`/exportservice/infolist`;
    }
    static exportserviceLocationRefUpdate(locid: number) {
        return this.fetchTerminalLocation(locid)+`/exportservice/ref`;
    }
    static exportserviceSioSend(locid: number) {
        return this.fetchTerminalLocation(locid)+`/exportservice/send`;
    }

    static siteReport(companyOrgNum: number) {
        return Routes.company(companyOrgNum)+`/sitereport`
    }
    static regReport(companyOrgNum: number) {
        return Routes.company(companyOrgNum)+`/registrations/report`;
    }
    static regReportXlsx(companyOrgNum: number) {
        return this.regReport(companyOrgNum)+".xlsx";
    }
    static regReportFilterCompanies(companyOrgNum: number) {
        return this.regReport(companyOrgNum)+`/filter-companies`;
    }
    static regReportFilterUsers(companyOrgNum: number) {
        return this.regReport(companyOrgNum)+`/filter-users`;
    }
    // NB: others use this
    static fetchTerminalLocation(id: number) {
        return `${this.baseurl}/terminal-location/${id}`
    }
    static fetchHmsregInfo(locid: number) {
        return Routes.fetchTerminalLocation(locid)+`/hmsreg/info`;
    }
    static hmsregLocationUpdate(locid: number) {
        return Routes.fetchTerminalLocation(locid)+`/hmsreg`;
    }
    static hmsregSend(locid: number) {
        return Routes.fetchTerminalLocation(locid)+`/hmsreg/send`;
    }
    static terminalsActiveOnLocation(locid: number) {
        return Routes.fetchTerminalLocation(locid)+`/terminals/active`;
    }
    static terminalsPendingOnLocation(locid: number) {
        return Routes.fetchTerminalLocation(locid)+`/terminals/pending`;
    }

    static siteReportXlsx(orgnum: number, locationId: number, from: DateTime, to: DateTime, filterOrgNum?: number) {
        return Routes.company(orgnum)+`/sitereport.xlsx?locationId=${locationId}&from=${from.toJSON()}&to=${to.toJSON()}&filterOrgNum=${filterOrgNum}`;
    }

    static onsiteCount(locid: number) {
        return Routes.fetchTerminalLocation(locid)+`/onsite/count`;
    }

    static onsiteLines(locid: number) {
        return Routes.fetchTerminalLocation(locid)+`/onsite/lines`;
    }

    private static sio(guid: string) {
        return `${this.baseurl}/sio/${guid}`;
    }
    static sioRegOutNow(guid: string) {
        return Routes.sio(guid)+`/time-out/now`;
    }
    static sioAdminRegOutNow(guid: string) {
        return Routes.sio(guid)+`/time-out/admin/now`;
    }
    static undoSioRegOut(guid: string, undoTxGuid: string) {
        return Routes.sio(guid)+`/time-out/undo/${undoTxGuid}`;
    }
    static userList(filterTxt: string, pageNum: number) {
        return `${Routes.baseurl}/user-list`;
    }
    static userData(personRef: string) {
        return `${Routes.baseurl}/user-data/${personRef}`;
    }
    static getLastIn(personRef: string) {
        return this.userData(personRef)+"/last-in";
    }

    static updateUvpInfo(personref: string) {
        return `${Routes.baseurl}/uvpinfo/${personref}`;
    }
    static removeUserRole(orgnum: number, personref: string, roleId: number, maybeLocationId: number | null) {
        let url = Routes.company(orgnum)+`/${personref}/role/remove?roleId=${roleId}`;
        if(maybeLocationId !== null && maybeLocationId > 0) {
            url += `&locationId=${maybeLocationId}`;
        }
        return url;
    }
    static fetchGrantableCompanies() {
        return `${Routes.baseurl}/companies/grantable`;
    }
    static addUserRole(orgnum: number, personref: string) {
        return Routes.company(orgnum)+`/${personref}/role`;
    }
    static mergePersons(fromGuid: string, toGuid: string) {
        return `${this.baseurl}/user-merge/${fromGuid}/${toGuid}`;
    }
    static undoPersonMerge(txid: number) {
        return `${this.baseurl}/undo-user-merge/${txid}`;
    }
    static fetchTerminals(orgnum: number) {
        return Routes.company(orgnum)+`/terminals`;
    }
    static fetchPendingTerminalSetups(orgnum: number) {
        return Routes.company(orgnum)+`/terminals/pending/setup`;
    }
    static fetchTerminal(guid: string) {
        return `${this.baseurl}/terminal/gui/info/${guid}`;
    }
    static terminalDisconnectAlarmPage(terminalGuid: string) {
        return `/web/terminal/${terminalGuid}/disconnect-alarm`;
    }
    static currentUser() {
        return `${this.baseurl}/user/current`;
    }
    private static terminal(guid: string) {
        return `${this.baseurl}/terminal/${guid}`;
    }
    static terminalDescriptionSave(guid: string) {
        return `${this.baseurl}/terminal/${guid}/description`;
    }
    static terminalContinuousPushlistenerSet(guid: string) {
        return `${this.baseurl}/terminal/${guid}/pushlistener/continuous`;
    }
    static fetchTerminalConfigNext(guid: string) {
        return `${this.baseurl}/terminal/${guid}/confignext`;
    }
    static terminalActivate(guid: string) {
        return `${this.baseurl}/terminal/${guid}/activate`;
    }
    static terminalDeactivate(guid: string) {
        return `${this.baseurl}/terminal/${guid}/deactivate`;
    }
    static terminalCleanupMark(guid: string) {
        return `${this.baseurl}/terminal/${guid}/cleanup`;
    }
    static terminalCleanupUndo(guid: string) {
        return this.terminalCleanupMark(guid)+"/undo";
    }
    static terminalLocationSet(guid: string) {
        return `${this.baseurl}/terminal/${guid}/location`;
    }
    static terminalSyncPush(guid: string) {
        return `${this.baseurl}/terminal/${guid}/push/sync`;
    }
    static terminalConfigPush(guid: string) {
        return `${this.baseurl}/terminal/${guid}/push/config`;
    }
    static addInvoicingExceptedTerminal() {
        return `/sysadm/invoicing/exceptions/add/terminal`;
    }
    static addInvoicingExceptedLocation() {
        return `/sysadm/invoicing/exceptions/add/location`;
    }
    static delInvoicingExceptedTerminal() {
        return `/sysadm/invoicing/exceptions/del/terminal`;
    }
    static delInvoicingExceptedLocation() {
        return `/sysadm/invoicing/exceptions/del/location`;
    }
    static fetchInvoicingExceptedTerminals(terminalGuid: string) {
        return `${this.baseurl}/terminal/${terminalGuid}/invoicing/excepted`;
    }
    static fetchInvoicingExceptedLocations(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/invoicing/excepted`;
    }
    static terminalAlarmstatus(terminalGuid: string) {
        return `${this.baseurl}/terminal/${terminalGuid}/alarmstatus`;
    }
    static terminalGeolocation(terminalGuid: string) {
        return `${this.baseurl}/terminal/${terminalGuid}/geolocation`;
    }
    static setDisconnectAlarmFromServer(terminalGuid: string, newState: number) {
        return `${this.baseurl}/terminal/${terminalGuid}/disconnect-alarm/${newState}`;
    }
    static fetchCustomerRef(orgnum: number) {
        return Routes.company(orgnum)+"/customer-ref";
    }
    static fetchRoleCompanies() {
        return `${this.baseurl}/companies/hasrole`;
    }
    static fetchUsermessages() {
        return `${this.baseurl}/usermessages`;
    }
    static unreadUsermessagesCount() {
        return this.fetchUsermessages()+"/unread/count";
    }
    static archiveUsermessage(guid: string) {
        return `${this.baseurl}/usermessages/${guid}/archive`;
    }
    static setUsermessageRead(guid: string) {
        return `${this.baseurl}/usermessages/${guid}/read`;
    }
    static fetchExportserviceHeaderRows(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/exportservice/header-rows`;
    }
    static fetchHmsregIntegrationCompany(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/hmsreg/companyinfo`;
    }
    static fetchHmsregIntegrationLocCount(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/hmsreg/loc-count`;
    }
    static fetchHmsregLocationStatuses(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/hmsreg/loc-statuses`;
    }
    static fetchHmsregLocationStatus(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/hmsreg/status`;
    }
    static hmsregIntegrationSettingsActivate(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/hmsreg/integration/activate`;
    }
    static hmsregIntegrationSettingsSave(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/hmsreg/integration/save`;
    }
    static hmsregIntegrationSettingsDeactivate(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/hmsreg/integration/deactivate`;
    }
    static autoTmcCompanySettings(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/auto_tmc_settings`;
    }
    static autoTmcFailedCount(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/auto_tmc_failed_count`;
    }
    static exportserviceSettingsCRUD(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/exportservice/crud`;
    }
    static fetchAllCompanies() {
        return `/sysadm/companies/all`;
    }
    static addSuperRole(orgnum: number) {
        return `/sysadm/${orgnum}/add-super`;
    }
    static saveCustomerRef(orgnum: number) {
        return `/sysadm/${orgnum}/customer-ref`;
    }
    static exportserviceDelete() {
        return `/sysadm/exportservice/delete`;
    }
    static addCompany() {
        return `/sysadm/company`;
    }
    static triggerLogsend(terminalGuid: string) {
        return `/sysadm/logsend/trigger/${terminalGuid}`;
    }
    static cleanupDevice(terminalGuid: string) {
        return `/sysadm/terminal/cleanup/${terminalGuid}`;
    }
    static reinitDevice(terminalGuid: string) {
        return `/sysadm/terminal/reinit/${terminalGuid}`;
    }
    static fetchPendingConfigs(orgnum: number) {
        return `/sysadm/${orgnum}/pendingconfigs`;
    }
    static deletePendingconfig(terminalGuid: string) {
        return `${this.baseurl}/terminal/setup/delete/${terminalGuid}`;
    }
    static newTerminalSetup() {
        return `${this.baseurl}/terminal/setup/new`;
    }
    static companyMigrate(orgnum: number) {
        return `/sysadm/${orgnum}/migrate`;
    }
    static companyMigratePost() {
        return `/sysadm/company/migrate`;
    }
    static superPage(orgnum: number) {
        return `/sysadm/${orgnum}`;
    }
    static loginPostJson() {
        return `/login/json`;
    }
    static loginRenew() {
        return `/login/renew`;
    }
    static fetchPhonelistReport(orgnum: number) {
        return Routes.company(orgnum)+`/persons/phonelist`;
    }
    static phonelistReportXlsx(orgnum: number, filterOrgnums: number[]) {
        const params = queryParams({filterOrgnums: filterOrgnums.length > 0 ? filterOrgnums.join(","): null});
        return Routes.company(orgnum)+`/persons/phonelist.xlsx${params}`;
    }
    static fetchAllUsersReport(orgnum: number) {
        return Routes.company(orgnum)+`/persons/allusers`;
    }
    static allUsersReportXlsx(orgnum: number, filterOrgnums: number[]) {
        const params = queryParams({filterOrgnums: filterOrgnums.length > 0 ? filterOrgnums.join(","): null});
        return Routes.company(orgnum)+`/persons/allusers.xlsx${params}`;
    }
    static fetchUserTermlocs() {
        return `${this.baseurl}/user/termlocs`;
    }
    static fetchUserRegreminderLocations() {
        return `${this.baseurl}/user/regreminder/termlocs`;
    }
    static setRegreminder(locid: number, enabled: boolean) {
        return `${this.baseurl}/user/location/${locid}/regreminder/${enabled}`;
    }
    static fetchUserSiteReport(locid: number) {
        return this.fetchTerminalLocation(locid)+`/user/sitereport`;
    }
    static removeSelfPhone(phone: PhoneNumber) {
        return `${this.baseurl}/phone/delete/${phone.countrycode}/${phone.number}`;
    }
    static undoRemoveSelfPhone(txid: number) {
        return `${this.baseurl}/phone/delete/undo/${txid}`;
    }
    static fetchPhoneCountryCodes() {
        return `${this.baseurl}/phone/countrycodes`;
    }
    static addPersonPhone(personref: string) {
        return `${this.baseurl}/person/${personref}/phone/add`;
    }
    static removePendingPhone(personref: string) {
        return `${this.baseurl}/person/${personref}/phone/del`;
    }
    static confirmPendingPhone() {
        return `${this.baseurl}/phone/pending/confirm`;
    }
    static resendPendingPhoneSecret(personref: string) {
        return `${this.baseurl}/person/${personref}/phone/resend`;
    }
    static addPersonEmail(personref: string) {
        return `${this.baseurl}/person/${personref}/email/add`;
    }
    static removePendingPersonEmail(id: number) {
        return `${this.baseurl}/person/email/pending/del/${id}`;
    }
    static removePersonEmail(id: number) {
        return `${this.baseurl}/person/email/del/${id}`;
    }
    static undoRemovePersonEmail(id: number) {
        return `${this.baseurl}/person/email/del/${id}/undo`;
    }
    static fetchPendingEmailConfirmInfo(secret: string) {
        return `${this.baseurl}/person/email/pending/${secret}/info`;
    }
    static confirmPendingEmailConfirmInfo(secret: string) {
        return `${this.baseurl}/person/email/pending/${secret}/confirm`;
    }
    static checkSessionLoginKey(key: string) {
        return `/login/pkey/session/check/${encodeURIComponent(key)}`;
    }
    static confirmLoginPKey(key: string) {
        return `/login/pkey/confirm/${encodeURIComponent(key)}`;
    }
    static loginLoginPKey(key: string) {
        return `/login/pkey/login/${encodeURIComponent(key)}`;
    }
    static sessionPhone() {
        return `${this.baseurl}/session/phone`;
    }
    static brregSearch(txt: string) {
        return `${this.baseurl}/brreg/search${queryParams({txt: txt})}`;
    }
    static pendingPersonAdd() {
        return `${this.baseurl}/person/pending/add`;
    }
    static pendingPersonAddPrelogin() {
        return `${this.baseurl}/person/pending/add/prelogin`;
    }
    static pendingPersonsList() {
        return `${this.baseurl}/person/pending/list`;
    }
    static pendingPersonDelete(guid: string) {
        return `${this.baseurl}/person/pending/delete/${guid}`;
    }
    static pendingPhoneCheck(phoneStr: string) {
        return `${this.baseurl}/phone/pending/${encodeURIComponent(phoneStr)}/check`;
    }
    static fetchPendingPhoneconfirm(key: string) {
        return `${this.baseurl}/phone/pending/${encodeURIComponent(key)}/confirminfo`;
    }
    static getLoginPkey() {
        return `/login/pkey/get`;
    }
    static getLoginCkey() {
        return `/login/ckey/get`;
    }
    static fetchPendingCardConfirm(key: string) {
        return `${this.baseurl}/card/pending/${encodeURIComponent(key)}/confirminfo`;
    }
    static setDefaultLoginCompany(orgnum: number) {
        return `${this.baseurl}/user/login-company/${encodeURIComponent(orgnum.toString())}`;
    }
    static confirmPendingCardPhone() {
        return `${this.baseurl}/card/pending/phone/confirm`;
    }
    static loginLoginCKey(key: string) {
        return `/login/ckey/login/${encodeURIComponent(key)}`;
    }
    static activePersonSio() {
        return `${this.baseurl}/person/activesio`;
    }
    static terminalLocationAreas(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/areas`;
    }
    static terminalLocationGeofences(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/geofences`;
    }
    static fetchAvailableTerminalLocations() {
        return `${this.baseurl}/sio/reg/locations/available`;
    }
    static sioRegIn() {
        return `${this.baseurl}/sio/reg/in`;
    }
    static personConfig() {
        return `${this.baseurl}/person/config`;
    }
    static simReportStatusOverdue() {
        return `/sysadm/sim/report/status-overdue`;
    }
    static com4ReconciliationReport() {
        return `/sysadm/sim/report/com4-reconciliation`;
    }
    static terminalsWithoutSIM() {
        return `/sysadm/sim/report/terminals-without-sim`;
    }
    static linkTerminalSIM() {
        return `/sysadm/sim/link-terminal`;
    }
    static com4ManualSIMs() {
        return `/sysadm/sim/com4-manual-sims`;
    }
    static com4ManualHistory() {
        return `/sysadm/sim/com4-manual-history`;
    }
    static com4OperationEvents(operationId: string) {
        return `/sysadm/sim/com4-operation/${encodeURIComponent(operationId)}/events`;
    }
    static com4ManualOperation() {
        return `/sysadm/sim/com4-manual-operation`;
    }
    static com4Refresh() {
        return `/sysadm/sim/com4-refresh`;
    }
    static com4UsageAllowance() {
        return `/sysadm/sim/com4-usage-allowance`;
    }
    static fetchSimRow(simSerial: string) {
        return `${this.baseurl}/sim/${encodeURIComponent(simSerial)}`;
    }
    static fetchUserRoleReport(orgnum: number) {
        return Routes.company(orgnum)+`/persons/roles`;
    }
    static cardQrInit() {
        return `${this.baseurl}/card/qr/init`;
    }
    static pendingCard(cardNum: number) {
        return `${this.baseurl}/card/pending/${cardNum}`;
    }
    static pendingCardAdd(cardNum: number) {
        return `${this.pendingCard(cardNum)}/add`;
    }
    static pendingCardMerge(cardNum: number) {
        return `${this.pendingCard(cardNum)}/merge`;
    }
    static pendingCardTakeover(cardNum: number) {
        return `${this.pendingCard(cardNum)}/takeover`;
    }

    static pendingPersonRoleAdd(orgnum: number) {
        return Routes.company(orgnum)+`/pending/person/role/add`;
    }
    static pendingPersonRoleRemove(orgnum: number) {
        return Routes.company(orgnum)+`/pending/person/role/remove`;
    }
    static terminalLocationShutdown(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/shutdown`;
    }
    static terminalLocationActivate(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/activate`;
    }
    static dismissCardAdd() {
        return `${this.baseurl}/card/missing/dismiss`;
    }
    static fetchPersonmergeUndoInfo() {
        return `${this.baseurl}/person/undo/info`;
    }
    static checkPhoneRegistration() {
        return `${this.baseurl}/login/phonecheck`;
    }
    static qrConnectAvailable() {
        return `${this.baseurl}/login/qrconnect/available`;
    }
    static pendingCardPersonAdd(phone: PhoneNumber) {
        return `${this.baseurl}/card/pending/person/${phone.countrycode}/${phone.number}`;
    }
    static pendingCardPhoneConnect(phone: PhoneNumber) {
        return `${this.baseurl}/card/pending/phone/connect/${phone.countrycode}/${phone.number}`;
    }
    static activeBillingLocationsInfo(orgnum: number) {
        return Routes.company(orgnum)+`/billing/info/locations`;
    }
    static activeBillingTerminalsInfo(orgnum: number) {
        return Routes.company(orgnum)+`/billing/info/terminals`;
    }
    static imeiSearch(imei: string) {
        return `${this.baseurl}/terminal/search/imei/${encodeURIComponent(imei)}`;
    }
    static getTerminalProresultIntegrationSetting(guid: string) {
        return this.terminal(guid)+"/proresult/integration/setting";
    }
    static getFamocoDeviceInfo(terminalGuid: string) {
        return this.terminal(terminalGuid)+"/famoco/device/info";
    }
    static refreshFamocoDeviceInfo(deviceId: number) {
        return `${this.baseurl}/famoco/device/${deviceId}/info/refresh`;
    }
    static logout() {
        return "/web/api/logout"
    }
    static fetchTerminalLocationRegcodes(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/regcodes`;
    }
    static createTerminalLocationRegcode(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/regcode/new`;
    }
    static setTerminalLocationRegcodeState(regcodeid: number) {
        return `${this.baseurl}/terminal-location/regcode/${regcodeid}/state`;
    }
    static registerRegcode() {
        return `${this.baseurl}/terminal-location/regcode/register`;
    }
    static forgetRegcode(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/regcode/forget`;
    }
    static terminalLocationPosterPdf(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/poster`;
    }
    static newMobileServerAuthtoken() {
        return `/web/api/mobile-server/authtoken/new`;
    }
    static checkCompanyInitBlocked(orgnum: number) {
        return Routes.company(orgnum)+`/init/blocked`;
    }
    static getBrregCompany(orgnum: number) {
        return `${this.baseurl}/brreg/${orgnum}`;
    }
    static saveCompanyAccount() {
        return `${this.baseurl}/company/account`;
    }
    static getCompanyAccount(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/account`;
    }
    static getCompanyAccountQuotas(orgnum: number) {
        return this.getCompanyAccount(orgnum)+`/quotas`;
    }
    static saveCompanyAccountQuotas(orgnum: number) {
        return this.getCompanyAccountQuotas(orgnum);
    }
    static savePurchaseOrder() {
        return `${this.baseurl}/purchaseorder`;
    }
    static getPurchaseOrder(id: number) {
        return this.savePurchaseOrder()+`/${id}`;
    }
    static listPurchaseOrders() {
        return `${this.baseurl}/purchaseorders`;
    }
    static deletePurchaseOrder(id: number) {
        return `${this.getPurchaseOrder(id)}`;
    }
    static increaseCompanyInvoiceException(orgnum: number) {
        return `/sysadm/${orgnum}/invoice-exception/increase`;
    }
    static reduceCompanyInvoiceException(orgnum: number) {
        return `/sysadm/${orgnum}/invoice-exception/reduce`;
    }
    static companyRegreminderEnabled(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/regreminder/enabled`;
    }
    static fetchCardExpirationReportLocations(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/persons/card/expiration/locations`;
    }
    static fetchCardExpirationReportCompanyCards(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/persons/card/expiration/companycards`;
    }
    static fetchUsersWithoutCardReport(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/persons/without-card`;
    }
    static fetchPersonsMissingPhoneReport(orgnum: number) {
        return `${this.baseurl}/company/${orgnum}/persons/without-phone`;
    }
    static addNotificationConfig() {
        return `${this.baseurl}/person/notification/config/add`;
    }
    static listNotificationConfigs() {
        return `${this.baseurl}/person/notification/config/list`;
    }
    static removeNotificationConfigs(id: number) {
        return `${this.baseurl}/person/notification/config/${id}/remove`;
    }
    static saveNotificationConfig() {
        return `${this.baseurl}/person/notification/config/save`;
    }
    static addNotificationSensor(configId: number) {
        return `${this.baseurl}/person/notification/config/${configId}/sensor/add`;
    }
    static removeNotificationSensor(id: number) {
        return `${this.baseurl}/person/notification/sensor/${id}/remove`;
    }
    static setTerminalTechnicalCheckDone(terminalGuidStr: string) {
        return `${this.baseurl}/terminal/${terminalGuidStr}/technical-check-done`
    }
    static setHseGuideline() {
        return `${this.baseurl}/hseguideline`;
    }
    static listHseGuideline(orgnum: number) {
        return Routes.company(orgnum) + `/hseguidelines`;
    }
    static deleteHseGuideline(id: number) {
        return `${this.baseurl}/hseguideline/${id}/delete`;
    }
    static getHseGuideline(locid: number) {
        return `${this.baseurl}/terminal-location/${locid}/hseguideline`
    }
    static confirmedHseGuidelineReport(locid: number) {
        return this.getHseGuideline(locid)+"/confirmreport";
    }
    static confirmHseGuideline(id: number, version: number) {
        return `${this.baseurl}/hseguideline/${id}/version/${version}/confirm`;
    }
    static fetchInfectiousPersonsLocations() {
        return `${this.baseurl}/infectiontrace/locations`;
    }
    static fetchInfectionTrace() {
        return `${this.baseurl}/infectiontrace/result`;
    }
    static xlsxInfectionTrace() {
        return this.fetchInfectionTrace()+".xlsx";
    }
    static fetchAllTermlocsShortInfo() {
        return `${this.baseurl}/terminal-location/all/shortinfo`;
    }
    static setFamocoStatus(deviceId: number, status: number) {
        return `/sysadm/famoco/${deviceId}/status/${status}`;
    }
    static activateFamocoDevice(terminalGuid: string) {
        return this.terminal(terminalGuid)+"/famoco/device/activate";
    }
    static triggerDataUseReport(terminalGuid: string) {
        return `/sysadm/terminal/${terminalGuid}/data-use/report/trigger`
    }
    static getDataUseReport(terminalGuid: string) {
        return `/sysadm/terminal/${terminalGuid}/data-use/report`
    }
    static setTerminalSoftDataLimits(terminalGuid: string) {
        return `/sysadm/terminal/${terminalGuid}/data-use/limits/soft`
    }
    static isUserAppReviewPending(os: string) {
        return `${this.baseurl}/person/app-review/pending/${os}`
    }
    static userAppReviewTriggered(os: string) {
        return `${this.baseurl}/person/app-review/triggered/${os}`
    }
    static recaptchaApproved() {
        return `${this.baseurl}/recaptcha/approved`
    }

    static readonly statsLocationCountMonths = `/sysadm/stats/locations/count`;
    static readonly statsInOutCountMonths = `/sysadm/stats/inout/count`;
    static readonly statsUserCountMonths = `/sysadm/stats/users/count`;
    static readonly statsTerminalCountMonths = `/sysadm/stats/terminals/count`;
    static readonly statsCompanyCountMonths = `/sysadm/stats/company/count`;
    static readonly statsCompanyAccountCreatedCountMonths = `/sysadm/stats/company/account/created/count`;
    static readonly statsCompanyInactivateMonths = `/sysadm/stats/company/inactive/count`;

    static readonly pages = {
        login : (redir: string | null = null) =>  `/login${queryParams({redir: redir})}`,
        locations: (orgnum: number) => `${routedefs.locations.path}${queryParams({orgnum: orgnum})}`,
        terminalOverview: `${routedefs.terminals.path}`,
        terminal: (orgnum: number, guid: string) => `${routedefs.terminals.terminal.paramPath(guid)}`,
        useradmin: (guid?: string) => `${routedefs.users.path}${queryParams({guid: guid || null})}`,
        userMessages: (orgnum: number) => `${routedefs.usermessages.path}`,
        settings: (orgnum?: number) => `${routedefs.system.path}${queryParams({orgnum: orgnum || null})}`,
        superIndex: (orgnum: number) => `${routedefs.super.path}${queryParams({orgnum: orgnum})}`,
        userReports: (orgnum: number) => `${routedefs.users.reports.path}${queryParams({orgnum: orgnum})}`,
        superSim: () => `${routedefs.super.sims.path}`,
        userSelfDisplay: (orgnum: number | null = null, termlocid: number | null = null) => {
            return `${routedefs.start.me.path}${queryParams({orgnum: orgnum, termlocid: termlocid})}`
        },
        //pendingTerminal: (orgnum: number, guid: string) => `${Routes.terminalOverviewPage(orgnum)}#/pending/${guid}`,
        location: (orgnum: number, locid: number) => `${routedefs.locations.path}/${locid}`,
        card: {
            add: (orgnum: number | null = null, termlocid: number | null = null) =>
                `${routedefs.start.card.add.path}${queryParams({orgnum: orgnum, termlocid: termlocid})}`,
            qrinfo: (orgnum: number | null = null, termlocid: number | null = null) =>
                `${routedefs.start.card.add.qrinfo.path}${queryParams({orgnum: orgnum, termlocid: termlocid})}`,
        },
    };
}
